import { render, staticRenderFns } from "./StickyCheckoutSummary.vue?vue&type=template&id=8e981418&scoped=true&"
import script from "./StickyCheckoutSummary.vue?vue&type=script&lang=js&"
export * from "./StickyCheckoutSummary.vue?vue&type=script&lang=js&"
import style0 from "./StickyCheckoutSummary.vue?vue&type=style&index=0&id=8e981418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e981418",
  null
  
)

export default component.exports